const fontWeights = [100, 200, 300, 400, 500, 600, 700, 800, 900];

const theme = {
  ...fontWeights,
  name: 'airbo',
  breakpoints: ['769px', '1200px', '1450px'],
  colors: {
    primary: {
      120: '#046EEF',
      100: '#007EFF',
      90: '#1A8BFF',
      80: '#3398FF',
      70: '#4DA5FF',
      60: '#66B2FF',
      50: '#80BFFF',
      40: '#99CBFF',
      30: '#B3D8FF',
      20: '#CCE5FF',
      10: '#E5F2FF',
    },
    black: {
      100: '#25282B',
      80: '#52575C',
      60: '#A0A4A8',
      40: '#CACCCF',
      20: '#DBDDE0',
      10: '#E8E8E8',
      5: '#F9F9FA',
    },
    shadow: '#888888',
    white: '#FFFFFF',
    notification: '#FF4747',
    peach: '#FF9385',
    red: '#ED1A3A',
    purple: '#7f9afd',
    grey: '#bbb9b9',
    background: '#FCF7F5',
    border: '#CACCCF',
    warning: {
      default: '#F6A609',
      darker: '#E89806',
      light: '#FFBC1F',
    },
    success: {
      default: '#2AC769',
      darker: '#1AB759',
      light: '#40DD7F',
      button: '#24c263',
      buttonDarken: '#26a459',
      hover: '#e4f8ec',
    },
    error: {
      default: '#EC0404',
      darker: '#D81818',
      light: '#FF6262',
      button: '#ef4646',
      buttonDarken: '#c73f41',
      medium: '#611724',
      background: '#f4d8db',
    },
  },
};

theme.mediaQueries = {
  forMediumUp: `@media screen and (min-width: ${theme.breakpoints[0]})`,
  forLargeUp: `@media screen and (min-width: ${theme.breakpoints[1]})`,
  forExtraLargeUp: `@media screen and (min-width: ${theme.breakpoints[2]})`,
  reducedMotion: `@(prefers-reduced-motion)`,
};

export default theme;
